<button data-cy="button" matButton="filled" [type]="type()" [title]="title()" [disabled]="disabled()">
  <ng-content></ng-content>
</button>
